module.exports = __webpack_public_path__ + "static/logos-tiles-cvs-68fc68bdc5cb87d3794a34d907298d4c.svg";